import { getConfig } from 'config/configuration';
import { useAppSelector } from 'store/hooks';

interface AtlasWebIframeProps {
  policyDetailsId: string;
  historyId: number;
  questionSetType: string;
}

export const atlasWebIFrameId = 'atlas-web';

const { policyPortalUrl } = getConfig();

export const AtlasWebIframe = ({ policyDetailsId, historyId, questionSetType }: AtlasWebIframeProps): JSX.Element => {
  const username = useAppSelector((state) => state.authentication.email);

  return (
    <iframe
      data-testid="payment-iframe"
      id={atlasWebIFrameId}
      name={atlasWebIFrameId}
      title={atlasWebIFrameId}
      src={`${policyPortalUrl}/api/landing/policy-details-id/${policyDetailsId}/history-id/${historyId}/type/${questionSetType}?userName=${username}`}
      width="100%"
      height={1500}
      scrolling="no"
      style={{ border: 'none', marginTop: '-16px' }}></iframe>
  );
};
